module.exports = __webpack_public_path__ + "media/images/article_sell_used_panties_img-e7c25733a9561482570ac50a49c404a7.svg";